module.exports = __webpack_public_path__ + "img/376.9b9a182b.png";